import { TextSource } from './types';

/**
 * Texte der Kontaktseite und des Kontaktblocks, der unter mehreren Seiten steht.
 *
 * Nicht enthalten sind die Beschriftungen im Formular selbst: Sie stehen zum Teil
 * in Attributen (`placeholder`) und in Fehlermeldungen, die sich an einer sichtbaren
 * Stelle nicht anfassen lassen. Sie bleiben im Code.
 */
export const KONTAKT: TextSource = {
  'kontakt.hero.eyebrow': 'Kontakt',
  'kontakt.hero.titel': 'Schreiben Sie uns',
  'kontakt.hero.titel-akzent': 'gerne!',
  'kontakt.hero.lead':
    'Wir freuen uns auf ein unverbindliches, kostenloses Kennenlerngespräch — persönlich in Gifhorn oder am Telefon.',

  'kontakt.daten.titel': 'So erreichen Sie uns',
  'kontakt.erreichbarkeit.titel': 'Erreichbarkeit',
  // Die Zeiten stehen so auch im Google-Unternehmensprofil und als
  // `openingHoursSpecification` in `public/index.html`. Google erwartet, dass
  // strukturierte Daten sichtbaren Inhalt abbilden — deshalb hier ausgeschrieben
  // und nicht nur „5 Tage die Woche". Bei einer Änderung alle drei Stellen nachziehen.
  //
  // Zwei Anschriften, bewusst in dieser Reihenfolge: Das Beratungsbüro im
  // Steinweg ist seit dem 22.09.2026 die öffentliche Adresse und steht überall
  // vorn — Fußzeile, JSON-LD, llms.txt, Unternehmensprofil, Verzeichnisse. Die
  // Celler Str. wird als Verwaltung genannt, nicht als zweite Hauptadresse:
  // Zwei gleichrangige Anschriften erschweren Google den Abgleich der Firma.
  'kontakt.erreichbarkeit.text':
    'Unser Beratungsbüro im Steinweg 66, mitten in der Gifhorner Innenstadt, ist **montags bis freitags von 9 bis 15 Uhr** und **samstags von 10 bis 14 Uhr** geöffnet. In der Celler Str. 63 sitzt unsere Verwaltung — auch dort können Sie vorbeikommen. Bei Notfällen erreichen Sie uns an **7 Tagen die Woche**.',
  'kontakt.karte.link': 'Anfahrt mit Google Maps planen',

  'kontakt.formular.titel': 'Nachricht senden',
  'kontakt.formular.text': 'Wir melden uns schnellstmöglich bei Ihnen zurück.',

  // Der Kontaktblock am Fuß der übrigen Seiten. Die Seiten können eigene Texte
  // übergeben; ohne Angabe gelten diese.
  // Neben den häufigen Fragen jeder Leistungsseite.
  'faq.weitere': 'Ihre Frage ist nicht dabei? Rufen Sie uns an — wir nehmen uns Zeit für Sie.',
  'kontakt.zeile.adresse': { text: 'Beratungsbüro', max: 24 },
  'kontakt.zeile.telefon': { text: 'Telefon', max: 24 },
  'kontakt.zeile.whatsapp': { text: 'WhatsApp', max: 24 },
  'kontakt.zeile.email': { text: 'E-Mail', max: 24 },

  'kontaktblock.titel': 'Schreiben Sie uns gerne!',
  'kontaktblock.text': 'Wir freuen uns auf ein unverbindliches, kostenloses Kennenlerngespräch.',

  // Das Formular selbst. Die Feldbeschriftungen (Vorname, E-Mail …) stehen in
  // Attributen und bleiben im Code — ebenso die Auswahlliste „Worum geht es?"
  // in `topics.ts` und die Fehlermeldungen des Servers.
  'formular.thema.label': { text: 'Worum geht es?', max: 40 },
  'formular.absenden': { text: 'Absenden', max: 30 },
  'formular.bewerbung-absenden': { text: 'Bewerbung absenden', max: 30 },
  'formular.sendet': { text: 'Wird gesendet …', max: 30 },
  'formular.hinweis': 'Wir verwenden Ihre Angaben ausschließlich, um Ihre Anfrage zu beantworten.',
  'formular.danke.titel': 'Vielen Dank für Ihre Nachricht!',
  // Der Satz endet offen: Dahinter steht die verlinkte Telefonnummer.
  'formular.danke.text':
    'Wir haben Ihre Anfrage erhalten und melden uns schnellstmöglich bei Ihnen zurück. Wenn es eilig ist, erreichen Sie uns telefonisch unter',
  'formular.danke.cta': { text: 'Weitere Nachricht schreiben', max: 40 },
};

export default KONTAKT;
